module.exports = __webpack_public_path__ + "static/media/live.a9c7e4b0.svg";